import React from 'react';

import { cssMap } from '@atlaskit/css';
import { Box, Stack } from '@atlaskit/primitives/compiled';
import Skeleton from '@atlaskit/skeleton';
import { token } from '@atlaskit/tokens';

import { PanelBody } from '../panel-body/panel-body';

const styles = cssMap({
	skeletonRow: {
		display: 'flex',
		alignItems: 'center',
		height: '1.25rem',
		width: '100%',
	},
});

const SkeletonRow = ({ width }: { width: string }) => {
	return (
		<Box xcss={styles.skeletonRow}>
			<Skeleton width={width} height="0.625rem" borderRadius={token('radius.full')} />
		</Box>
	);
};

export function PanelBodySkeleton(): JSX.Element {
	return (
		<PanelBody>
			<Stack space="space.100">
				<SkeletonRow width="75%" />
				<SkeletonRow width="90%" />
				<SkeletonRow width="80%" />
				<SkeletonRow width="85%" />
			</Stack>
		</PanelBody>
	);
}
